import React from 'react'

import { Button, BUTTON_THEME, Chip, CHIP_TYPES, Icon } from '@st-operations/uikit/src/v2'
import format from '@st-operations/uikit/lib/format.js'

import './styles.scss'

const TopicsList = ({ title, topics, handleAddTopic, handleAddMultipleTopics }) => {
  return (
    <div className="topics-list">
      <div className="topics-list__header">
        <p>{title}</p>
        <div>
          <Button onClick={() => handleAddMultipleTopics(topics)} theme={BUTTON_THEME.GHOST}>
            <Icon icon="plus2" type="fill" width="14px" height="14px" color="#3D3D3D" /> Add All
            Topics
          </Button>
        </div>
      </div>
      <div className="topics-list__body">
        <For each="topic" of={topics ?? []}>
          <Chip
            key={topic.name}
            value={`${topic.name} ${format('metric', topic.sizes?.sharethis)}`}
            onClick={() => handleAddTopic(topic)}
            onButtonClick={() => handleAddTopic(topic)}
            small
            hasAddIcon
            type={CHIP_TYPES.FILL}
            className="topics-card__chip"
            iconStyle={{ fill: 'currentColor' }}
          />
        </For>
      </div>
    </div>
  )
}

export default TopicsList
